var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyTrackingUrlIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.191,
    height: 11.801,
    viewBox: "0 0 10.191 11.801",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-content-copy",
    "data-name": "Icon material-content-copy",
    d: "M10.509,1.5H4.073A1.076,1.076,0,0,0,3,2.573v7.509H4.073V2.573h6.437Zm1.609,2.146h-5.9A1.076,1.076,0,0,0,5.146,4.718v7.509A1.076,1.076,0,0,0,6.218,13.3h5.9a1.076,1.076,0,0,0,1.073-1.073V4.718A1.076,1.076,0,0,0,12.119,3.646Zm0,8.582h-5.9V4.718h5.9Z",
    transform: "translate(-3 -1.5)",
    fill: "#040227"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyTrackingUrlIcon);
export default __webpack_public_path__ + "static/media/copy-tracking-url-icon.b11ab1610d7012d5047ea90331e7fffd.svg";
export { ForwardRef as ReactComponent };